import { Component, OnInit, ViewChild, AfterContentInit } from "@angular/core";
import { Router } from "@angular/router";
import { ChatComponent } from "../chat.component";

@Component({
  selector: "app-chat-page",
  templateUrl: "./chat-page.component.html",
  styleUrls: ["./chat-page.component.scss"],
})
export class ChatPageComponent implements OnInit, AfterContentInit {
  @ViewChild(ChatComponent) chatComponent: ChatComponent;

  constructor(private router: Router) {}

  ngOnInit() {}

  ngAfterContentInit() {
    // Ensure chat is always visible on the chat page
    if (this.chatComponent) {
      this.chatComponent.setChatVisibility(true);
      this.chatComponent.setTitle("PSR WEBCHAT");
    }
  }
}
